var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.pageActive === 'home')?_c('Home',{attrs:{"data":_vm.data},on:{"showChat":_vm.showChat}}):_c('PreviewChat',{attrs:{"data":_vm.data},on:{"editChatOptions":_vm.showConfiguration}}),_c('UNotice')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }